import React from 'react';
import { Label, Select as FlowbiteSelect } from 'flowbite-react';
import Select from 'react-select'

interface SelectInputProps {
    items: any[],
    className?: string,
    label?: string,
    displayKey?: string,
    valueKey?: string,
    onChange?: (value: string) => void;
    name?: string;
    value?: string;
    isSearchable?: boolean
}

const CustomSelectInput = ({ items, value, isSearchable, className, label, displayKey, valueKey, onChange, name }: SelectInputProps) => {
    const options = items.map(item => ({
        value: valueKey ? item[valueKey] : item,
        label: displayKey ? item[displayKey] : item
    }));
        

    return (
        !isSearchable ? (
            <div>
                {label && <Label value={label} htmlFor={name} />}
                <FlowbiteSelect name={name} value={value} onChange={(e) => onChange && onChange(e.target.value)}>
                    <option>Select</option>
                    {items.map((item, index) => (
                        <option key={index} value={valueKey ? item[valueKey] : displayKey ? item[displayKey] : item}>
                            {displayKey ? item[displayKey] : item }
                        </option>
                    ))}
                </FlowbiteSelect>
            </div>) : (
            <div>
                {label && <Label value={label} htmlFor={name} />}
                <Select
                    name={name}
                    value={options.find(option => option.value === value) || null}
                    onChange={(selectedOption) =>
                        onChange && onChange(selectedOption?.value || '')
                    }
                    options={options}
                    isSearchable={true}
                    placeholder="Select"

                />
            </div>

        )
    );
};

export default CustomSelectInput;

// import React, { useState, useRef, useEffect } from 'react';
// import { Label, TextInput } from 'flowbite-react';
// import { FaChevronDown } from 'react-icons/fa';

// interface SelectInputProps {
//     items: any[],
//     className?: string,
//     label?: string,
//     displayKey?: string,
//     valueKey?: string,
//     onChange?: (value: string) => void;
//     name?: string;
//     value?: string;
//     isSearchable?:boolean
// }

// const CustomSelectInput = ({ items, value,isSearchable, className, label, displayKey, valueKey, onChange, name }: SelectInputProps) => {
//     const [searchTerm, setSearchTerm] = useState<string>('');
//     const [isOpen, setIsOpen] = useState<boolean>(false);
//     const [selectedValue, setSelectedValue] = useState<string>(value || '');

//     const dropdownRef = useRef<HTMLDivElement>(null);

//     // Filter items based on the search term
//     const filteredItems = items.filter((item) =>
//         displayKey
//             ? item[displayKey]?.toLowerCase().includes(searchTerm.toLowerCase())
//             : item.toLowerCase().includes(searchTerm.toLowerCase())
//     );

//     const handleSelect = (item: any) => {
//         const selected = valueKey ? item[valueKey] : displayKey ? item[displayKey] : item;
//         setSelectedValue(selected);
//         setIsOpen(false); // Close the dropdown
//         onChange && onChange(selected);
//     };

//     const handleDropdownToggle = () => {
//         setIsOpen(!isOpen);
//     };

//     // Close the dropdown if clicked outside
//     const handleClickOutside = (event: MouseEvent) => {
//         if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
//             setIsOpen(false);
//         }
//     };

//     useEffect(() => {
//         document.addEventListener('mousedown', handleClickOutside);
//         return () => document.removeEventListener('mousedown', handleClickOutside);
//     }, []);

//     return (
//         <div className={`relative ${className}`} ref={dropdownRef}>
//             {label && <Label value={label} htmlFor={name} />}

//             {/* Display selected value with dropdown toggle */}
//             <div
//                 className="border border-gray-300 p-2 rounded cursor-pointer flex justify-between items-center"
//                 onClick={handleDropdownToggle}
//             >
//                 <span>{selectedValue || 'Select'}</span>
//                 <FaChevronDown />
//             </div>

//             {/* Dropdown with search input */}
//             {isOpen && (
//                 <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded shadow-lg z-10">
//                     {isSearchable && <TextInput
//                         placeholder="Search..."
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         className="mb-2 p-2"
//                     />}
//                     <div className="max-h-40 overflow-y-auto">
//                         {filteredItems.length > 0 ? (
//                             filteredItems.map((item, index) => (
//                                 <div
//                                     key={index}
//                                     className="p-2 hover:bg-gray-100 cursor-pointer"
//                                     onClick={() => handleSelect(item)}
//                                 >
//                                     {displayKey ? item[displayKey] : item}
//                                 </div>
//                             ))
//                         ) : (
//                             <div className="p-2 text-gray-500">No items found</div>
//                         )}
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default CustomSelectInput;

